import {MsMichelinActivatorAuth} from '@/utils'

/**
 * 'Auth.service'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
const auth = new MsMichelinActivatorAuth(process.env.API_URL + 'auth/token', {name: 'invoice'})
export default auth



// WEBPACK FOOTER //
// ./src/services/auth.service.js